import React from 'react';
import { Modal, ModalHeader, ModalBody } from '@americanexpress/dls-react';
import { useModal } from '@/context/modalContext';
import { useRouteParams } from '@/context/routeParamsContext';
import { useLoungeMapImages } from '@/hooks/loungesHooks/loungesHelperHooks';
import { useCommonContent } from '@/hooks/oneCmsIntlHooks/oneCmsIntlHelperHooks';

const LocationMapModal = () => {
  const { loungeId } = useRouteParams();
  const { closeModal } = useModal();
  const {
    centurionNetwork: { loungeMap },
  } = useCommonContent();
  const { largeMapImage } = useLoungeMapImages(loungeId);
  const id = 'location-map';

  return (
    <Modal
      id={id}
      onClose={(e) => closeModal(e, 'close location map')}
      innerContainerClassName="tw-modal-inner-container"
    >
      <ModalHeader
        id={`${id}-header`}
        closeButtonProps={{ reactlytics: { disable: true } }}
      >
        <h3>{loungeMap?.modalHeader}</h3>
      </ModalHeader>
      <ModalBody id={`${id}-content`} className="tw-modal-body">
        {largeMapImage && (
          <img
            src={largeMapImage}
            alt={loungeMap?.largeImageAltText}
            style={{ width: '100%' }}
          />
        )}
      </ModalBody>
    </Modal>
  );
};

export default LocationMapModal;
